import React, { Component } from 'react';
import Inner from './Inner';
import './Contact.css';

export default class Contact extends Component {
	render() {
		return(
			<Inner title="Contact the artist">
			<p>I'd love to hear from you. If you'd like to get in touch, please <a href="mailto:otto178@aol.com?Subject=Contact from website">email me</a> and I'll get back to you.</p>
			</Inner>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Contact.js